export default "https://cdn-static.gokick.com/assets/b944ecdade3ab4b24738bd1fcec1eea00d00fb75/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";